// extracted by mini-css-extract-plugin
export default {"input":"lsf-input","textarea":"lsf-textarea","input__spinner":"lsf-input__spinner","waiting-spin":"lsf-waiting-spin"};
    if(module.hot) {
      // 1732531518693
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  